<ng-container *ngLet="dataContext | async">
  <div id="featuredPartsHome_div_IsLoading" *ngIf="isLoading">
    <h5 class="ps-4">Loading featured products...</h5>
  </div>
  <ng-container id="featuredPartsHome_div_IsNotLoading" *ngIf="!isLoading" class="w-100">
    <part-card-list title="Featured Products" [parts]="featuredParts" [partType]="featuredProductType"></part-card-list>
  </ng-container>
</ng-container>
